import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  (_, props: { size?: string | number }) => ({
    extensionCard: {
      width: props?.size,
      height: props?.size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })
)
